module.exports = __webpack_public_path__ + "static/img_slideshow_03-8cedc3f5c81717ebf9ee3dce8acb8386.jpg";